import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const RwandaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15841'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15841)'>
				<g filter='url(#filter0_d_2332_15841)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 14.0001H20V10.2667H0V14.0001Z'
						fill='#2D754D'
					/>
				</g>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 6.53333H20V0H0V6.53333Z'
					fill='#25B1EB'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 10.2667H20V6.53333H0V10.2667Z'
					fill='#FECB2F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M15.2387 4.20002L14.5098 4.99127L14.5653 3.92666L13.479 3.98103L14.2864 3.26669L13.479 2.55235L14.5653 2.60672L14.5098 1.54212L15.2387 2.33336L15.9677 1.54212L15.9122 2.60672L16.9985 2.55235L16.1911 3.26669L16.9985 3.98103L15.9122 3.92666L15.9677 4.99127L15.2387 4.20002Z'
					fill='#FECB2F'
				/>
			</g>
			<defs>
				<filter
					id='filter0_d_2332_15841'
					x='0'
					y='10.2667'
					width='20'
					height='3.73328'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_15841'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_15841'
						result='shape'
					/>
				</filter>
			</defs>
		</svg>
	);
};

export default RwandaFlagIcon;
